import { ERROR_TYPES } from 'modules/event-manager/event-manager-error';
import { ERROR_KEYS } from 'constants/app.constants';

export const TEXT_KEYS = {
    MESSAGE: {
        [ERROR_TYPES.NOT_ELIGIBLE]: ERROR_KEYS.WIDGET_ERROR_NOT_ELIGIBLE,
        [ERROR_TYPES.SOMETHING_WRONG]: ERROR_KEYS.WIDGET_ERROR_MESSAGE
    }
};
